// Barkmoor cart sign-up (2 Oct 2026). Step 1: apply the welcome code to the cart (fetch).
// Step 2: submit Shopify's own customer form normally, so Shopify's invisible spam captcha runs
// (a fetch() POST is rejected with 400, and a submit into a hidden frame never completes), with
// return_to=/cart so the shopper lands on the cart page with the 10% already showing.
// One document-level listener, because the cart drawer is re-rendered after every cart change.
if (!window.__barkCartSignup) {
  window.__barkCartSignup = true;

  // After the sign-up, Shopify's redirect jumps to its #contact_form anchor (the footer sign-up),
  // past all the products. Coming back from OUR sign-up, go to the top so the cart is in view.
  let fromSignup = false;
  try { fromSignup = sessionStorage.getItem('barkSignup') === '1'; sessionStorage.removeItem('barkSignup'); } catch (e) {}
  if (fromSignup) {
    if (location.hash) history.replaceState(null, '', location.pathname + location.search);
    const top = () => window.scrollTo(0, 0);
    top();
    window.addEventListener('load', () => { top(); setTimeout(top, 50); setTimeout(top, 300); });
  }

  const say = (form, text) => {
    const msg = form.querySelector('.bark-signup__msg');
    if (msg) { msg.textContent = text; msg.hidden = false; }
  };

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.classList.contains('bark-signup__form')) return;
    if (form.dataset.barkReady) return; // second pass: let Shopify (and its captcha) submit it
    event.preventDefault();
    event.stopPropagation();
    const input = form.querySelector('input[type="email"]');
    const email = (input?.value || '').trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { say(form, 'Please enter a valid email.'); return; }
    if (form.dataset.barkBusy) return;
    form.dataset.barkBusy = '1';
    form.querySelector('button')?.setAttribute('disabled', '');
    say(form, 'Adding your 10% off…');
    const code = form.closest('bark-cart-signup')?.dataset.code;
    try {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: code }),
      });
    } catch (e) { /* the welcome email still carries the code */ }
    if (!form.querySelector('input[name="return_to"]')) {
      const r = document.createElement('input');
      r.type = 'hidden'; r.name = 'return_to'; r.value = '/cart';
      form.appendChild(r);
    }
    try { sessionStorage.setItem('barkSignup', '1'); } catch (e) {}
    form.dataset.barkReady = '1';
    if (form.requestSubmit) form.requestSubmit(); else form.submit();
  }, true);
}
